<template>
  <BaseNew    
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    addButtonIcon="mdi-bank-plus"
    :newCreateButtonLabel="newCreateButtonLabel"
    :newSaveButtonLabel="newSaveButtonLabel"
    :useModelInsteadOfButton="useModelInsteadOfButton"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :clients="clients"
        :extraData="extraData"
        :multiSale="multiSale"
        :modelNameSingular="modelNameSingular"
      />

      <NfpeNew
        ref="nfpeNew"
        :multiSale="multiSale"        
        :useModelInsteadOfButton="true"
        modelNameSingular="NFP-e">
      </NfpeNew>
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";
import NfpeNew from "@models/fiscal_documents/outbounds/nfes/nfpes/new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      clients: [],
      formErrors: [],
      extraData: {},
      selectedItems: [],
      multiSale: {personId: null, sales: []}
    };
  },
  props: {
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    inlineAddButton: {
      default: false,
      type: Boolean
    },
    newCreateButtonLabel: {
      type: String,
      default: "Faturar multiplas vendas"
    },
    newSaveButtonLabel: {
      type: String,
      default: "Faturar"
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew,
    NfpeNew: NfpeNew,
  },
  methods: {
    loadServerEntry: function() {      
      this.error = null;
      this.loading = true;
      
        this.$apollo
          .query({
            query: ALL_CLIENTS_WITH_SALES,
            fetchPolicy: "no-cache"
          })
          .then(response => {
            this.clients = response.data.accountContext.allClientsWithSales;            
            // this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));      
    },  
    createEntry: function() {
      // console.log("feito", this.multiSale)
      if (this.multiSale.sales.length > 0){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created");
        this.resetForm();
        if (this.$refs.nfpeNew) {
          if (this.$refs.nfpeNew.$refs.baseNew) {
            this.$refs.nfpeNew.$refs.baseNew.openAction();
          }
        }
      } else {
        // ver erros
        this.formErrors = errors;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.multiSale.personId = null
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const ALL_CLIENTS_WITH_SALES = gql `
  {
    accountContext{
      allClientsWithSales{
        id
        name
      }
    }
  }
`;

</script>

<style scoped></style>
